import {
  MakerIndexResponse,
  MakerWithCategoriesResponse,
} from "@/web-client/api";
import { useMemo } from "react";

type MakerPage = {
  hasVisualImages: boolean;
};

const useMakerPage = (
  maker?: MakerIndexResponse | MakerWithCategoriesResponse,
): MakerPage => {
  const hasVisualImages = useMemo(() => {
    if (!maker) return false;

    return maker.visual_images && maker.visual_images.length > 0;
  }, [maker]);

  return {
    hasVisualImages,
  };
};
export default useMakerPage;
